import React, { Component } from "react";
import { connect } from "react-redux";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { publishedCourse, openCourseModal, editCourse } from "CourseAction";
import LocaleStrings from "Languages";

class CourseItem extends Component {
  constructor(props) {
    super(props);
    this.state = { isPublish: false };
  }

  handlePublishUnpublish = () => {
    let { session, listItem, currentPage } = this.props;
    let option = true;
    let message = LocaleStrings.course_publish_form_published_success;

    if (listItem && listItem.ispublished) {
      option = false;
      message = LocaleStrings.course_publish_form_unpublished_success;
    }
    var values = { courseid: listItem.courseid, ispublished: option };

    this.setState({ isPublish: true });
    this.props.publishedCourse(session, values, (response) => {
      this.setState({ isPublish: false });

      if (response.success) {
        this.props.pagination(currentPage);
        this.props.showSuccess(message);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  editRecord = () => {
    let { listItem } = this.props;
    this.props.openCourseModal({
      showModal: true,
      action: "update",
      record: listItem,
    });
    this.props.editCourse({ data: listItem });
  };

  render() {
    let { listItem } = this.props;
    let { isPublish } = this.state;

    let published = listItem && listItem.ispublished ? true : false;

    return (
      <tr>
        <td>
          <div className="vcenter">{listItem.coursename}</div>
        </td>
        <td>
          <div className="vcenter">
            {listItem.course_chapter_by_courseid.length}
          </div>
        </td>
        <td>
          <div className="vcenter">
            {listItem.course_lessons_by_courseid.length}
          </div>
        </td>
        <td>
          <div className="row" style={{ display: "flex" }}>
            <div className="">
              <button className="i-custom-table-edit" onClick={this.editRecord}>
                <img
                  className="i-custom-normal"
                  src="../../style/images/custom-icons/edit.svg"
                />
              </button>
            </div>

            {listItem &&
            listItem.course_chapter_by_courseid &&
            listItem.course_chapter_by_courseid.length > 0 &&
            listItem.ticketid ? (
              <div className="">
                <label className="course-switch-button-container">
                  <input
                    type="checkbox"
                    onChange={isPublish ? null : this.handlePublishUnpublish}
                    checked={published}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      isPublish ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            ) : (
              ""
            )}
          </div>
        </td>
      </tr>
      // <div className="col-xl-6 col-lg-5 col-md-4">
      //     <div className="vcenter">{listItem.coursename}</div>
      // </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  publishedCourse,
  openCourseModal,
  editCourse,
})(CourseItem);
